module.exports = __webpack_public_path__ + "static/icon-f4deaea774c6de0125b5ee4ff94d64a1.png";